/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createLinkSuccessfulStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    lineHeight: '48px',
    letterSpacing: '-0.32px',
    textAlign: 'center',
    margin: '0 0 72px',
  },
  link: {
    textDecoration: 'none',
  },
}));
